export const getInboxNotificationState = panelStates => {
  const states = Object.values(panelStates);

  if (states.some(state => state.count > 0)) return 'content';
  if (states.some(state => state.error)) return 'error';
  if (states.some(state => state.loading)) return 'loading';

  return 'empty';
};
